<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="addTab" v-if="!load">
            <b-tab title="مرحلة هيكلة الخطة">
              <app-timeline>
                <app-timeline-item
                  v-for="item in items"
                  :key="item.id"
                  :title="$t(`master.` + item.key)"
                  :subtitle="variant(item) ? 'في انتظار الموافقة ' : 'موافقة '"
                  :time="moment(item.updated_at).fromNow()"
                  :variant="variant(item) ? 'danger' : 'success'"
                />
              </app-timeline>
              <b-spinner
                v-if="load"
                type="grow"
                label="Loading..."
                class="loading"
              />
            </b-tab>
            <b-tab @click="newItem = {}" :title="$t('site.add')">
              <form-wizard
                color="#80b02c"
                :subtitle="null"
                :title="null"
                :finish-button-text="$t('site.finish')"
                :back-button-text="$t('site.back')"
                :next-button-text="$t('site.next')"
                @on-complete="formSubmitted"
                :start-index="tab"
                step-size="sm"
                ref="wizard"
              >
                <b-card>
                  <tab-content
                    :title="$t('master.defense_of_the_structuring_plan')"
                    :before-change="
                      () => validateStep('defense_of_the_structuring_plan')
                    "
                  >
                    <online-session-vue v-if="defense_of_the_structuring_plan"
                      :mediaData="
                        defense_of_the_structuring_plan.online_session
                      "
                    ></online-session-vue>
                    <!-- online_session -->
                  </tab-content>
                  <tab-content
                    :title="$t('master.upload_research_plan')"
                    :before-change="() => validateStep('upload_research_plan')"
                  >
                    <research-plan-vue ref="upload_research_plan" />
                  </tab-content>
                </b-card>
              </form-wizard>
            </b-tab>
          </b-tabs>
          <b-spinner v-else type="grow" label="Loading..." class="loading" />
        </div>

        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import uploadVue from "./wizard/upload.vue";
import Auth from "@/Apis/Auth";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import MastersDataController from "@/Controllers/MastersDataController";
import ResearchPlanVue from "./wizard/ResearchPlan.vue";
import MasterKeyStatusController from "@/Controllers/MasterKeyStatusController";
import MastersController from "@/Controllers/MastersController";
import SettingController from "@/Controllers/SettingController";
import OnlineSessionController from "@/Controllers/OnlineSessionController";
import OnlineSessionVue from "./wizard/OnlineSession.vue";

// Department
export default {
  components: {
    FormWizard,
    TabContent,
    uploadVue,
    AppTimeline,
    AppTimelineItem,
    ResearchPlanVue,
    OnlineSessionVue,
  },
  data() {
    return {
      tab: 0,
      items: [],
      load: false,
      addTab: 1,
      research_field: [],
      suggested_title: [],
      general_idea_of_the_topic: [],
      masterId: Auth.MASTER.id,
      defense_of_the_structuring_plan: { online_session: {} },
      time:"",
    };
  },

  async created() {
    this.load = true;
    this.time = await new SettingController().time();

    const timeLine = new MastersController().timeLine();
    const key = timeLine
      .find((a) => a.code == "plan_structuring_phase")
      .phases.map((a) => {
        return a.code;
      });
    const res = await new MasterKeyStatusController().GetAll({
      filter: "master_id|" + this.masterId,
      filterIn: "key|" + key.toString(),
      with: ["mastersData", "onlineSession"],
    });

    this.items = res;

    this.upload_research_plan = this.getData(
      "upload_research_plan",
      0
    ).masters_data;
    this.defense_of_the_structuring_plan = this.getData(
      "defense_of_the_structuring_plan",
      1
    )[0];
    this.tab=0;
    console.log(this.defense_of_the_structuring_plan);
    this.load = false;
    if (res.length == 3) this.addTab = 0;
  },
  methods: {
    checkTime(item) {
      if (!item) return false;
      const check = new Date(this.time.SERVERTIME);
      const stDate = Auth.GetDateTimeZone(item.start_in, true);
      if (check.getTime() >= stDate.getTime()) return false;
      return true;
    },
    openLive(data) {
      new OnlineSessionController().joinLecture(data.id);
    },
    getData(key, tab) {
      const find = this.items.filter((a) => a.key == key);
      if (!find) return [];

      this.tab = tab;

     //  this.$refs["wizard"].changeTab(0, this.tab);

      return find;
    },
    variant(item) {
      return item.value == null || item.value == "" || item.value == "-1";
    },
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      
      // if (name == "defense_of_the_structuring_plan") {
      //   console.log("in");
      //   if (!this.defense_of_the_structuring_plan) {
        
      //     return false};
      //   if (this.defense_of_the_structuring_plan.value == 0) return false;
      //   if (this.defense_of_the_structuring_plan.online_session.is_end == 1)
      //     return true;
      // }
      const returnData = await refToValidate.returnData();
      console.log(name);
      console.log(refToValidate);
      console.log(returnData.valid);
      if (!returnData.valid) return false;

      return true;
    },
    async formSubmitted() {
      this.$router.push({ name: "Thesis" });
    },
  },
};
</script>

<style>
</style>